import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

/**
 *
 * @param buttonName parameter for any generalised button in AC and PPC
 * @returns instance of page segment load experience
 */
export const ButtonExperience = (buttonName: string) => {
  return new UFOExperience(`${buttonName}`, {
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
    type: ExperienceTypes.Operation,
  });
};
